









































import Vue, { PropType } from 'vue'
import Dialog from '@/components/Dialog.vue'
import { Messenger, SubRegionCrud, TableHeader } from '@/utils/interfaces'
import { Remittance } from '~/utils/interfaces/remittance.interface'
export default Vue.extend({
  components: {
    appDialog: Dialog,
  },
  props: {
    item: Object as PropType<Messenger>,
    remittance: Object as PropType<Remittance>,
  },
  data() {
    return {
      headers: [
        {
          text: this.$t('subregion'),
          value: 'subregion_name',
        },
        {
          text: this.$t('commission'),
          value: 'fixed_commission',
        },
        {
          text: this.$t('active'),
          value: 'fixed_commission',
        },
      ] as TableHeader[],
      fields: [
        'username',
        'first_name',
        'last_name',
        'email',
        'phone',
        'balance',
        'full_address',
      ],
    }
  },
  computed: {
    subregions(): SubRegionCrud[] {
      const config = this.item.messenger_configs?.find(
        conf => conf.delivery_currency === this.remittance.delivery_currency,
      )
      if (config) {
        return config.subregion_commissions
      }
      return []
    },
  },
})
